class Popup {
  constructor(options) {
    this.params = {};
    if (options.overlay) {
      this.overlay = options.overlay;
    } else {
      this.overlay = document.querySelector('.popup--common');
    }
    if (options.button) {
      this.button = options.button;
    }
    this.popup = this.overlay.querySelector(options.popup);
    this.callbackElem = this.popup.querySelector('.popup-callback');
    this.type = options.type;
    if (options.close_btn) {
      this.close_btn = options.close_btn;
    } else {
      this.close_btn = this.popup.querySelector('.popup__close');
    }
    if (typeof (Event) === 'function') {
      this.resizeEvent = new window.Event('resize');
    } else {
      this.resizeEvent = document.createEvent('Event');
      this.resizeEvent.initEvent('resize', true, true);
    }
    this.init();
  }

  init() {
    const popupContainer = this.overlay.querySelector('.popup__container');
    this.overlay.addEventListener('click', (event) => {
      const containsTarget = this.popup.contains(event.target);
      if ((event.target === this.overlay || event.target === popupContainer) && !containsTarget) {
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.keyCode === 27) {
        this.close();
      }
    });

    if (this.button) {
      this.button.addEventListener('click', (e) => {
        e.preventDefault();

        this.open();
      });
    }

    if (this.close_btn) {
      this.close_btn.addEventListener('click', () => {
        this.close();
      });
    }
  }

  open() {
    this.constructor.stopBodyMove(true);
    window.bodyLock.disableBodyScroll(this.overlay, {
      allowTouchMove: (el) => {
        while (el && el !== document.body) {
          if (el.getAttribute('body-scroll-lock-ignore') !== null) {
            return true;
          }

          el = el.parentElement;
        }

        return false;
      },
    });
    const allOverlays = [].slice.call(document.querySelectorAll('.popup'));
    allOverlays.forEach(tmp => tmp.classList.remove('popup--open'));
    const allPopups = [].slice.call(document.querySelectorAll('.popup__content-wrap'));
    allPopups.forEach(tmp => tmp.classList.remove('popup__content-wrap--open'));
    this.overlay.classList.add('popup--open');
    this.popup.classList.add('popup__content-wrap--open');

    if (this.type) {
      this.popup.classList.add('popup__content-wrap--new');
      if (this.callbackElem) {
        this.callbackElem.className = 'popup-callback';
        this.callbackElem.classList.add(`popup-callback--${this.type}`);
      }
    } else {
      this.popup.classList.remove('popup__content-wrap--new');
      if (this.callbackElem) this.callbackElem.className = 'popup-callback';
    }

    setTimeout(() => {
      window.dispatchEvent(this.resizeEvent);
    }, 605);
  }

  close() {
    window.bodyLock.clearAllBodyScrollLocks();
    this.overlay.classList.remove('popup--open');
    this.popup.classList.remove('popup__content-wrap--open');
    this.constructor.stopBodyMove(false);
  }

  static stopBodyMove(add) {
    if (add) {
      const width = document.body.offsetWidth;
      document.body.style.maxWidth = `${width}px`;
    } else {
      setTimeout(() => {
        document.body.style.maxWidth = '';
      }, 0);
    }
  }
}

export default Popup;



// WEBPACK FOOTER //
// ./blocks/popup/popup.js